import React from 'react';
import HeaderComponent from '../commons/header';
import Footer2Component from '../commons/footer2';
import Splash_About from '../commons/splash_about';

import {IndexLink, Link} from 'react-router';

export default class AboutPage extends React.Component {
    render() {
        return (
            <div id="page_other">
                <HeaderComponent title="About"/>
                <Splash_About/>
                <div className={"footerClear"}>&nbsp;</div>
                <Footer2Component/>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/about.js
 **/